import React, { useState } from 'react'
import PropTypes from 'prop-types'

/**
 * This is a temporary replacement to fix Select on IE11. As soon as element-react
 * is updated to fix the infinite loop issue, the new version of the library
 * should be used instead of this.
 * @param {} props
 */
const Select = props => {
    const { children, name, onChange, placeholder, value } = props
    const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
    const [selectedOption, setselectedOption] = useState(value)

    const labelsByKeys = {}
    for (let i = 0; i < children.length; i++) {
        const currentOption = children[i]
        labelsByKeys[currentOption.value] = currentOption.label
    }

    return (
        <div className="input-container">
            <div className="el-select">
                <div
                    className="el-input"
                    onClick={() => setDropdownIsOpen(prev => !prev)}
                >
                    <i
                        className={`el-input__icon el-icon-caret-top${
                            dropdownIsOpen ? ' is-reverse' : ''
                        }`}
                    />
                    <input
                        placeholder="Select"
                        name={name}
                        readOnly=""
                        type="text"
                        className="el-input__inner"
                        autoComplete="off"
                        value={
                            labelsByKeys[selectedOption]
                                ? labelsByKeys[selectedOption]
                                : placeholder
                                ? placeholder
                                : 'Select'
                        }
                    />
                </div>
                {dropdownIsOpen && (
                    <div
                        className="el-select-dropdown"
                        style={{
                            minWidth: '570px',
                            position: 'absolute',
                            bottom: '50px',
                            left: '0px',
                            willChange: 'top, left',
                        }}
                    >
                        <div className="el-scrollbar">
                            <div
                                className="el-select-dropdown__wrap el-scrollbar__wrap"
                                style={{
                                    marginRight: '-17px',
                                    marginBottom: '-17px',
                                }}
                            >
                                <ul
                                    className="el-scrollbar__view el-select-dropdown__list"
                                    style={{ position: 'relative' }}
                                >
                                    {children.map(option => (
                                        <li
                                            className={`el-select-dropdown__item ${
                                                option.className
                                                    ? option.className
                                                    : ''
                                            }${
                                                selectedOption === option.value
                                                    ? ' selected'
                                                    : ''
                                            }`}
                                            key={option.key}
                                            onClick={() => {
                                                setselectedOption(option.value)
                                                onChange(option.value)
                                                setDropdownIsOpen(false)
                                            }}
                                        >
                                            {option.element}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

Select.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    children: PropTypes.node,
    value: PropTypes.string,
    onChange: PropTypes.func,
}

export default Select
